import { usePaginatedMessages } from "hooks/usePaginatedMessages";
import { useDispatch } from "react-redux";
import { setMediaSliderActive } from "store/slices/channelInfoSlider";
import { useChannelStateContext, useChatContext } from "stream-chat-react";
import { ChannelInfoWrapper } from "../ChannelInfoWrapper";
import { FileIcon } from "components/design/FileIcon";
import { Files } from "components/icons/Files";

export const MediaDocuments = ({ groupId }: { groupId: string }) => {
  const { client } = useChatContext();
  const { channel } = useChannelStateContext();
  const dispatch = useDispatch();

  const { messages: messagesWithImages } = usePaginatedMessages(
    client,
    {
      id: channel.id,
    },
    {},
    { limit: 30 },
    {
      "attachments.type": { $in: ["image"] },
    }
  );

  const { messages: messagesWithattachments } = usePaginatedMessages(
    client,
    {
      id: channel.id,
    },
    {},
    { limit: 30 },
    {
      attachments: { $exists: true },
    }
  );

  const images = messagesWithImages
    .flatMap((m) => m.message.attachments)
    .filter((m) => m?.type === "image");

  const attachments = messagesWithattachments.flatMap(
    (m) => m.message.attachments
  );

  const openMediaSlider = () => {
    dispatch(setMediaSliderActive(true));
  };

  if (!images.length && !attachments.length) {
    return null;
  }

  return (
    <ChannelInfoWrapper
      title={
        <div className="t-text-subtext t-flex t-gap-1 t-items-center">
          Media And Documents
        </div>
      }
      openDetails={openMediaSlider}
    >
      {" "}
      <div className="t-flex t-gap-3 t-overflow-x-scroll">
        {images.map((image) => (
          <img
            key={image?.id}
            src={image?.image_url}
            className="t-h-16 t-w-16 t-object-cover t-rounded t-border t-border-neutral-0 t-border-solid"
            alt={image?.fallback}
          />
        ))}
        {attachments.map((file) => (
          <div className="t-bg-surface-lighter-grey t-rounded" key={file?.id}>
            <FileIcon fileType="PDF" size="64" />
          </div>
        ))}
      </div>
    </ChannelInfoWrapper>
  );
};
